import _ from 'lodash'
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Tooltip,
  Cell
} from 'recharts'
import { Tip } from '@vzmi/shp_shared_compo'
import PieLabel from '../../../../../Common/NewDashboard/Chart/PieLabel/PieLabel'
import CustomizedTooltip from './CustomizedTooltip/CustomizedTooltip'
import styles from './SummariesChart.css'
import { COLORS } from '../ReturnSummaries'
import {
  FIELD as SORT_TYPE,
  FIELD_MAP as SORT_TYPE_MAP
} from '../SummariesTable/SummariesTable'

export const getTopThreeSummaries = summariesWithPercent => {
  const topThreeSummaries = _.slice(summariesWithPercent, 0, 3)
  return topThreeSummaries
}

const SummariesChart = props => {
  const { data, sortType } = props
  const topThreeSummaries = getTopThreeSummaries(data)
  return (
    <>
      <ResponsiveContainer
        width='100%'
        height='100%'
        minHeight='410px'
      >
        <PieChart>
          <Pie
            dataKey='percent'
            isAnimationActive={false}
            data={data}
            cx='50%'
            cy='50%'
            outerRadius={100}
            labelLine={false}
            label={(
              <PieLabel
                topPies={topThreeSummaries}
                pieKey={SORT_TYPE.REASON}
              />
            )}
            // 讓第一個 pie 從 0 度開始
            startAngle={90}
            endAngle={-270}
          >
            {
              data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  stroke=''
                  fill={COLORS[index % COLORS.length]}
                />
              ))
            }
          </Pie>
          <Tooltip content={<CustomizedTooltip sortType={sortType} />} />
        </PieChart>
      </ResponsiveContainer>
      <Tip
        type='info'
        className={styles.tips}
      >
        {`依${SORT_TYPE_MAP[sortType]}顯示`}
      </Tip>
    </>
  )
}

export default SummariesChart
